/* eslint-disable jsx-a11y/no-onchange */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable import/first */
declare var Accept: any;
import React, { FC, ReactElement, useState, useEffect } from 'react';
import withLocalization from '../hoc/withLocalization';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import { withRouter } from 'react-router-dom';
import {
  setPaymentFormToken,
  resetPaymentData,
  bookConfirmationPayment,
  setpaymentLoader,
  createLeadWithBooking,
  resetPaymentContextId,
  resetPaymentModalError,
  payerAuthConfirmation,
  resetAllPaymentPageDetails,
  clearPayerAuthDetails,
  retrieveUCPaymentContext,
  setTestPaymentContextId,
  retrieveUCPaymentDetails,
} from '../../features/newOfferPayment/NewOfferPaymentSlice';
import { bookPaymentPayload } from '../../features/newOfferPayment/bookPaymentRequestMapping';
import { billingRequestPayload } from '../../util/leadRequestMapping';
import PaymentErrorModal from '../NewOffer/PaymentErrorModal/PaymentErrorModal';
import { payerAuthPayload } from '../../util/payerAuthMapping';
import CyberSourceErrorModal from '../common/CommonOfferComponent/CyberSourceErrorModal/CyberSourceErrorModal';
import { IP_ADDR_REQUEST_URL } from '../../util/strings';
import { pinFlowPaymentPayload } from '../../util/pinFlowPaymentRequestMapping';
import { pinFlowAuthPayload } from '../../util/pinFloPayerAuthMap';
import { CaptureContextBody } from './types';
import TermsAndConditionPage from '../NewOffer/PaymentDetailsPage/TermAndConditionPage';
import {
  UnifiedCheckoutContextPayload,
  UnifiedCheckoutPaymentDetailPayload,
} from '../NewOffer/NewOfferCyberSource/types';
import leftArrowLogo from '../../features/siteTheme/Brands/tmvcs/logo/leftArrowLogo.svg';
import leftArrowHover from '../../features/siteTheme/Brands/tmvcs/logo/leftArrowHover.svg';
import NewOfferLoader from '../common/CommonOfferComponent/NewOfferLoader/NewOfferLoader';
import { analyticsData } from '../../analyticsTypes';
import { getPaymentTypeFromToken } from '../NewOffer/NewOfferCyberSource/paymentUtil';
import { useMediaQuery } from 'react-responsive';
import { refinePackageData } from '../../util/packagingOverviewMapping';
import PackageOverviewSummary from '../NewOffer/PackageOverviewPage/PackageOverviewSummary';
import { formateZipCode } from '../../util/CommonLogic';
import './UnifiedCheckout.scss';

interface UnifiedCheckoutFormType {
  history: any;
  localize: any;
  localizeImagesByNode: any;
  logAnalytics: (data: analyticsData) => void;
}
const UnifiedCheckout: FC<UnifiedCheckoutFormType> = (props: UnifiedCheckoutFormType): ReactElement => {
  const { history, localize, localizeImagesByNode, logAnalytics } = props;
  const [secureAcceptanceLoaded, setsecureAcceptanceLoaded] = useState(false);
  const hasError = useSelector((state: RootState) => state.newOfferPaymentDetails.hasPaymentContextError);
  const paymentContextId = useSelector((state: RootState) => state.newOfferPaymentDetails.paymentContextId);
  const newOfferDetailsInfo: any = useSelector((state: RootState) => state.newOfferDetails.newOfferData);
  const isPinOptFlow: boolean = useSelector((state: RootState) => state.pinOptFlowDetails.pinOptFLow);
  const offerDetails: any = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);
  const newOfferData = isPinOptFlow ? offerDetails : newOfferDetailsInfo;
  const offerData: any = (newOfferData?.offers && newOfferData?.offers[0]) || '';
  const packageData = refinePackageData(offerData);
  const roomType = (offerData?.roomTypes && offerData?.roomTypes[0]) || {};
  const depositAmt = roomType?.depositAmount || '';
  const billingInfo = useSelector((state: RootState) => state.newOfferPaymentDetails.billingDetailInfo);
  const contactInfo = useSelector((state: RootState) => state.newOfferDetails.reservationContactInfo);
  const pinPospectInfo: any = useSelector((state: RootState) => state.offerDetails.prospect) || '';
  const pinLeadDetails: any = useSelector((state: RootState) => state.pinOptFlowDetails.pinOptFlowLeadInfo);
  const isCallMe: boolean = useSelector((state: RootState) => state.pinOptFlowDetails.isContactMeChecked);
  const pinDetails: any = useSelector((state: RootState) => state.pinOptFlowDetails.pinDetails);
  const getLeadDetail = useSelector((state: RootState) => state.newOfferDetails.newOfferLeadDetail);
  const newurlParams = useSelector((state: RootState) => state.newOfferDetails.urlData);
  const pinurlParams = useSelector((state: RootState) => state.pinOptFlowDetails.urlData);
  const urlParams = isPinOptFlow ? pinurlParams : newurlParams;
  const isModalErr = useSelector((state: RootState) => state.newOfferPaymentDetails.paymentModalError);
  const modalErrMsg = useSelector((state: RootState) => state.newOfferPaymentDetails.paymentModalErrMsg);
  const modalErrStatus = useSelector((state: RootState) => state.newOfferPaymentDetails.paymentModalErrStatus);
  const payAuthDetails = useSelector((state: RootState) => state.newOfferPaymentDetails.PayerAuthDetails);
  const isPaymentErr = useSelector((state: RootState) => state.newOfferPaymentDetails.paymentError);
  const hasContextError = useSelector((state: RootState) => state.newOfferPaymentDetails.hasPaymentContextError);
  const transientToken = useSelector((state: RootState) => state.newOfferPaymentDetails.transientToken);
  const authEnrollDetails = useSelector((state: RootState) => state.newOfferPaymentDetails.paymentAuthEnrollDetails);
  const payerAuthRefId = useSelector((state: RootState) => state.newOfferPaymentDetails.referenceId);
  const confirmationDetails = useSelector((state: RootState) => state.newOfferPaymentDetails.confirmationDetails);
  const isPaymentCheck = useSelector((state: RootState) => state.newOfferPaymentDetails.isPaymentCheckBox);
  const mailingData: any = useSelector((state: RootState) => state.newOfferPaymentDetails.mailingAddressInfo);
  const ucBillToDetails = useSelector((state: RootState) => state.newOfferPaymentDetails.ucPaymentDetails);
  const useTestCaptureContext = process.env.REACT_APP_USE_TEST_CAPTURE_CONTEXT?.toLowerCase() === 'true';
  const [testCaptureContext, setTestCaptureContext] = useState('');
  const webUrl = urlParams?.url || '';
  const isLoading = useSelector((state: RootState) => state.newOfferPaymentDetails.pageLoading);
  const [isTokenErr, setIsTokenErr] = useState(false);
  const [showErrModal, setShowErrModal] = useState(false);
  const [ipAddress, setSetIpAddress] = useState('');
  const [termsError, setTermError] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [isCaptureContext, setIsCaptureContext] = useState(false);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: `(max-width: 500px)` });
  const scriptId = 'secure-acceptance-script-id';
  const paymentMethodImage = localizeImagesByNode(
    'preview-sales-engine.static-content.images.payment-methods-image',
    'unified-checkout-payment-methods-desktop-main',
  );
  const mobPaymentMethodImage = localizeImagesByNode(
    'preview-sales-engine.static-content.images.payment-methods-image',
    'unified-checkout-payment-methods-mobile-main',
  );
  const paymentMethodImagePath = isMobile ? mobPaymentMethodImage?.path || '' : paymentMethodImage?.path || '';
  const paymentMethodImageAlt = isMobile
    ? mobPaymentMethodImage?.description || ''
    : paymentMethodImage?.description || '';

  const handlelogAnalytics = (data: analyticsData) => {
    // bubble event to parent
    if (logAnalytics) {
      logAnalytics(data);
    }
  };

  const handleTestCaptureContextChange = (evt) => {
    const testCC = evt.target.value;
    setTestCaptureContext(testCC);
    dispatch(setTestPaymentContextId(testCC));
  };

  const handleClickOnBack = () => {
    setIsCaptureContext(true);
    setTestCaptureContext('');
    dispatch(resetPaymentData());
    dispatch(resetAllPaymentPageDetails());
    dispatch(resetPaymentContextId());
    sessionStorage.removeItem('pbeJwtToken');
    if (isPinOptFlow) {
      history.push('/offer-details');
    } else {
      const getUrlSearchParam = sessionStorage.getItem('urlSearchParam');
      history.push('/contact-information' + getUrlSearchParam);
    }
  };

  useEffect(() => {
    if ((!paymentContextId || paymentContextId.length === 0) && !hasError && isCaptureContext === false) {
      console.log({ UnifiedCheckout_useTestCaptureContext: useTestCaptureContext });
      if (useTestCaptureContext) {
        dispatch(setTestPaymentContextId(testCaptureContext));
      } else {
        const zipCodeVal: any = formateZipCode(pinPospectInfo?.postalCode);
        const ucContextPayload: UnifiedCheckoutContextPayload = {
          targetOrigins: [window.location.origin],
          country: 'US',
          locale: 'en_US',
          captureMandate: {
            billingType: 'FULL',
            requestEmail: false,
            requestPhone: false,
            requestShipping: false,
            showAcceptedNetworkIcons: true,
          },
          orderInformation: {
            amountDetails: {
              totalAmount: depositAmt.replace('$', '').replace(',', ''),
              currency: 'USD',
            },
            billTo: {
              firstName: pinPospectInfo?.firstName || contactInfo?.firstName || '',
              lastName: pinPospectInfo?.lastName || contactInfo?.lastName || '',
              address1: mailingData?.address || pinPospectInfo?.addressLine1 || '',
              buildingNumber: '',
              locality: mailingData?.city || pinPospectInfo?.city || '',
              administrativeArea:
                mailingData?.stateCode || pinPospectInfo?.stateProvince || contactInfo?.stateCode || '',
              country: 'US',
              postalCode: mailingData?.zipCode || zipCodeVal || '',
            },
          },
        };
        dispatch(
          retrieveUCPaymentContext(
            process.env.REACT_APP_MERCHANT_GROUPID_3DS ? process.env.REACT_APP_MERCHANT_GROUPID_3DS : '',
            ucContextPayload,
          ),
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentContextId]);

  useEffect(() => {
    if (paymentContextId && paymentContextId.length > 0) {
      const captureContext: CaptureContextBody = JSON.parse(atob(paymentContextId.split('.')[1]));
      const clientLibrary = captureContext?.ctx?.[0].data?.clientLibrary ?? '';
      const script = document.createElement('script');
      script.src = clientLibrary;
      script.integrity = captureContext?.ctx?.[0].data?.clientLibraryIntegrity ?? '';
      script.id = scriptId;
      script.crossOrigin = 'anonymous';
      script.async = true;
      script.onload = () => {
        setsecureAcceptanceLoaded(true);
      };
      document.head.appendChild(script);
      console.log({
        uc_url: clientLibrary,
        paymentContextId: paymentContextId,
        captureContext: captureContext,
      });
      return () => {
        script.remove();
        //document.head.removeChild(script);
      };
    }
  }, [paymentContextId]);

  useEffect(() => {
    fetch(IP_ADDR_REQUEST_URL)
      .then((response) => response.json())
      .then((data) => {
        const ipAdd = data?.ip || 'Unknown IP Address';
        setSetIpAddress(ipAdd);
      });
  }, []);

  useEffect(() => {
    if (hasContextError) {
      setIsTokenErr(true);
    }
  }, [hasContextError]);

  const submitPayment = (cdlId, refId, trID) => {
    const paymentType = getPaymentTypeFromToken(transientToken);
    const isdigitalWallet = paymentType?.value === 'CC' ? false : true;
    const getToken: any = sessionStorage.getItem('pbeJwtToken');
    const requestBookingData = isPinOptFlow
      ? pinFlowPaymentPayload(
          offerData,
          billingInfo,
          pinPospectInfo,
          getToken,
          refId,
          trID,
          ipAddress,
          pinLeadDetails,
          isCallMe,
          pinDetails,
          mailingData,
          ucBillToDetails,
        )
      : bookPaymentPayload(
          offerData,
          billingInfo,
          contactInfo,
          getToken,
          getLeadDetail,
          cdlId,
          refId,
          trID,
          ipAddress,
          ucBillToDetails,
        );

    if (getLeadDetail || isPinOptFlow) {
      dispatch(bookConfirmationPayment(requestBookingData, isdigitalWallet));
    } else {
      const getOfferType: any = sessionStorage.getItem('offer-type');
      const isPaid = getOfferType === 'paid' ? true : false;
      const paramState = isPaid ? billingInfo?.state : contactInfo?.state;
      const createLeadPayload = billingRequestPayload(
        contactInfo,
        newOfferData,
        true,
        paramState,
        billingInfo?.zipCode,
        webUrl,
      );
      const payloadObj = { leadRequestObj: createLeadPayload, bookingRequestObj: requestBookingData };
      dispatch(createLeadWithBooking(payloadObj, isdigitalWallet));
    }
  };

  const payerAuthEnrollment = (payAttempt) => {
    const cardinal = window.Cardinal;
    console.log('we are in Enrollment');
    cardinal?.continue(
      'cca',
      {
        AcsUrl: payAttempt.acsUrl,
        Payload: payAttempt.paReq,
      },
      {
        OrderDetails: {
          TransactionId: payAttempt.transactionId,
        },
      },
    );

    cardinal?.on('payments.validated', async (data, cardinaljwt) => {
      console.log('After cardinal CONTINUE we are in payment validate data - ', data?.ActionCode);
      const validateData = data?.ActionCode?.toUpperCase() || 'default';
      if (validateData === 'FAILURE' || validateData === 'ERROR') {
        setShowErrModal(true);
      } else {
        const prTransId = data?.Payment?.ProcessorTransactionId || payAttempt.transactionId;
        submitPayment('', '', prTransId);
      }
    });
  };

  const setupCardinal = (cardinalJwt: any, referenceId: any, token: any, methodName?: any) => {
    const cardinal = window.Cardinal;
    console.log('we are in cardinal setup');
    console.log('is window cardinal define - ', cardinal);

    cardinal?.configure({
      logging: {
        level: 'on',
      },
    });
    cardinal?.setup('init', {
      jwt: cardinalJwt,
    });
    cardinal?.on('payments.setupComplete', function (setupCompleteData) {
      console.log('submit OTP');
      submitPayment(cardinalJwt, payerAuthRefId, '');
    });
  };

  useEffect(() => {
    if (payAuthDetails && payAuthDetails?.payerAuthEnabled && payAuthDetails?.referenceId !== '') {
      //dispatch(setpaymentLoader(false));
      const getToken = sessionStorage.getItem('pbeJwtToken');
      setupCardinal(payAuthDetails?.cardinalJwt, payAuthDetails?.referenceId, getToken);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payAuthDetails]);

  useEffect(() => {
    if (authEnrollDetails?.status?.toLowerCase() === 'pending_authentication') {
      //dispatch(setpaymentLoader(false));
      payerAuthEnrollment(authEnrollDetails);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authEnrollDetails]);

  useEffect(() => {
    const confirmationStatus = confirmationDetails?.status?.toLowerCase() || '';
    if (confirmationStatus === 'pending_authentication') {
      payerAuthEnrollment(confirmationDetails);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmationDetails]);

  useEffect(() => {
    if (isModalErr && modalErrStatus) {
      const errSt = modalErrStatus.toUpperCase();
      if (errSt === 'IIB_ERROR' || errSt === 'PAYMENT_DONE_BOOKING_FAILED') {
        if (isPinOptFlow) {
          history.push('/thank-you');
        } else {
          const getUrlSearchParam = sessionStorage.getItem('urlSearchParam');
          history.push('/thank-you' + getUrlSearchParam);
        }
      } else {
        setShowErrModal(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalErr, modalErrStatus]);

  if (isPaymentErr) {
    history.push({
      pathname: '/error',
    });
  }

  const confirmAndContinue = (token: string) => {
    dispatch(setPaymentFormToken(token));
    // set billing info from token
    const ucPaymentDetailPayload: UnifiedCheckoutPaymentDetailPayload = {
      transientToken: token,
    };
    dispatch(
      retrieveUCPaymentDetails(
        process.env.REACT_APP_MERCHANT_GROUPID_3DS ? process.env.REACT_APP_MERCHANT_GROUPID_3DS : '',
        ucPaymentDetailPayload,
      ),
    );
  };

  const closePaymentErrModal = () => {
    setTermsAccepted(false);
    const btnContainer = document.getElementById('buttonPaymentListContainer');
    const formContainer = document.getElementById('embeddedPaymentContainer');
    if (btnContainer) btnContainer.innerHTML = '';
    if (formContainer) formContainer.innerHTML = '';
    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      document.head.removeChild(existingScript);
      setsecureAcceptanceLoaded(false); // Optional: update state
      console.log('Secure Acceptance script removed');
    }
    setTestCaptureContext('');
    dispatch(resetPaymentData());
    dispatch(resetPaymentContextId());
    dispatch(resetPaymentModalError());
    dispatch(resetAllPaymentPageDetails());
    dispatch(clearPayerAuthDetails());
    setShowErrModal(false);
    setIsTokenErr(false);
    sessionStorage.removeItem('pbeJwtToken');
    /*if (isPinOptFlow) {
      const getUrlSearchParam = sessionStorage.getItem('pinOptUrlSearchParam') || '';
      history.push('/offer-details' + getUrlSearchParam);
    } else {
      const getUrlSearchParam = sessionStorage.getItem('urlSearchParam');
      history.push('/contact-information' + getUrlSearchParam);
    }*/
  };

  useEffect(() => {
    const showArgs = {
      containers: {
        paymentSelection: '#buttonPaymentListContainer',
        paymentScreen: '#embeddedPaymentContainer',
      },
    };
    console.log({ paymentContextId_UC: paymentContextId });
    if (secureAcceptanceLoaded && paymentContextId && paymentContextId.length > 0) {
      const captureContext = JSON.parse(atob(paymentContextId.split('.')[1]));
      console.log({ captureContext_UC: captureContext });
      Accept(paymentContextId)
        .then((accept) => {
          console.log({ accept: accept });
          //have to pass in false when paymentScreen is configured to inline in containers
          return accept.unifiedPayments(false);
          //if paymentScreen is not included above, need to pass in empty value, which will use sidebar for payment entry
          // return accept.unifiedPayments();
        })
        .then((up) => {
          console.log({ up: up });
          return up.show(showArgs);
        })
        .then((tt) => {
          // this occurs when user clicks 'Confirm and 'Continue'
          console.log({ transietToken: tt });
          sessionStorage.setItem('pbeJwtToken', tt);
          confirmAndContinue(tt);
        })
        .catch((error) => {
          console.log(error);
          dispatch(setpaymentLoader(false));
          setIsTokenErr(true);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentContextId, secureAcceptanceLoaded]);

  // create use effect after billing info is set in confirmandContinue
  useEffect(() => {
    if (billingInfo?.address) {
      try {
        const paymentType = getPaymentTypeFromToken(transientToken);
        const isCreditCard = paymentType?.value === 'CC' ? true : false;
        const isdigitalWallet = paymentType?.value === 'CC' ? false : true;
        const analyticsData: analyticsData = {
          googleData: {
            event: 'add_payment_info',
            otherData: {
              payment_type: paymentType.text,
            },
          },
          adobeData: {
            event: 'PbeSubmitPayment',
            bookingStepName: 'MVC | PBE Payment',
            otherData: {
              paymentType: paymentType.text,
            },
          },
        };
        handlelogAnalytics(analyticsData);
        if (isCreditCard) {
          const requestBookingData = isPinOptFlow
            ? pinFlowPaymentPayload(
                offerData,
                billingInfo,
                pinPospectInfo,
                transientToken,
                '',
                '',
                ipAddress,
                pinLeadDetails,
                isCallMe,
                pinDetails,
                mailingData,
              )
            : bookPaymentPayload(
                offerData,
                billingInfo,
                contactInfo,
                transientToken,
                getLeadDetail,
                '',
                '',
                '',
                ipAddress,
              );
          const authData = isPinOptFlow
            ? pinFlowAuthPayload(offerData, billingInfo, pinPospectInfo, transientToken, ipAddress, pinLeadDetails)
            : payerAuthPayload(offerData, billingInfo, contactInfo, transientToken, ipAddress);
          const isLeadId = getLeadDetail ? true : false;
          //do not use Billing state for paid flow only as state is now collected on contact info for all flows
          const paramState = contactInfo?.state;
          const createLeadPayload = isPinOptFlow
            ? {}
            : billingRequestPayload(contactInfo, newOfferData, true, paramState, billingInfo?.zipCode, webUrl);

          const payloadObj = {
            leadRequestObj: createLeadPayload,
            bookingRequestObj: requestBookingData,
            authDataObj: authData,
            isLeadId: isLeadId,
            ispinOptFlow: isPinOptFlow,
          };
          console.log({ UC_confirmAndContinue_payloadObj: payloadObj });
          dispatch(payerAuthConfirmation(payloadObj, isdigitalWallet));
        } else {
          submitPayment('', '', '');
        }
      } catch (error) {
        console.log(error);
        dispatch(setpaymentLoader(false));
        setIsTokenErr(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billingInfo]);

  const showTermError = () => {
    if (!isPaymentCheck) {
      setTermError(localize('preview-sales-engine.static-content.copy.pbeo.terms-conditions-error-message'));
    } else {
      setTermError('');
    }
  };

  const handlePaymentMethodImageClick = () => {
    showTermError();
  };

  useEffect(() => {
    if (isPaymentCheck != termsAccepted) {
      setTermsAccepted(isPaymentCheck);
      showTermError();
    }
  }, [isPaymentCheck]);

  return (
    <>
      {isLoading && <NewOfferLoader />}
      {showErrModal && <PaymentErrorModal closeModal={closePaymentErrModal} msg={modalErrMsg} />}
      {isTokenErr && <CyberSourceErrorModal closeModal={closePaymentErrModal} />}
      {useTestCaptureContext && (
        <textarea
          id={'test-capture-context'}
          style={{ width: '100%' }}
          value={testCaptureContext}
          onChange={handleTestCaptureContextChange}
          // className="pin-input-cls"
        />
      )}
      <div className="uc-package-overview-summary">
        <span className="uc-label">{localize('preview-sales-engine.static-content.copy.pbeo.summary-label')}</span>
        <PackageOverviewSummary packageData={packageData} />
      </div>
      <div className="uc-terms-container">
        <span className="uc-label">
          {localize('preview-sales-engine.static-content.copy.pbeo.terms-and-conditions-label')}
        </span>
        <TermsAndConditionPage />
        {termsError && <span className="uc-terms-err">{termsError}</span>}
      </div>
      <div className="uc-payment-methods-container" style={{ display: !isPaymentCheck ? 'flex' : 'none' }}>
        <span className="uc-label">
          {localize('preview-sales-engine.static-content.copy.pbeo.payment-methods-header')}
        </span>
        <input
          type="image"
          src={paymentMethodImagePath}
          alt={paymentMethodImageAlt}
          onClick={handlePaymentMethodImageClick}
        ></input>
      </div>
      <div
        className="uc-main-container"
        style={{ display: isPaymentCheck && paymentContextId && paymentContextId.length > 0 ? 'flex' : 'none' }}
      >
        <div className="uc-button-container" id="buttonPaymentListContainer"></div>
        <div className="uc-payment-container" id="embeddedPaymentContainer"></div>
      </div>
      <div className="payment-btn-container">
        <button onClick={handleClickOnBack} className={`payment-back-btn`}>
          <img src={leftArrowLogo} alt="Back" className="back-icon-payment" />
          <img src={leftArrowHover} alt="Back" className="back-icon-payment-hover" />
          {localize(`preview-sales-engine.static-content.copy.pbeo.back-button-label`)}
        </button>
      </div>
    </>
  );
};

export default withRouter(withLocalization(UnifiedCheckout));
